import { SegmentEvent } from '@/integrations/segment/SegmentEvent';
import { OnboardingJurisdictionCompletedEventTracking } from '@/modules/auth/models/segmentevents/OnboardingJurisdictionCompletedEventTracking';

export class ViewedStandardTriageSituationPageEventTracking extends OnboardingJurisdictionCompletedEventTracking {
  static eventName: SegmentEvent = SegmentEvent.VIEWED_STANDARD_TRIAGE_SITUATION_PAGE;
}
